import { JuniorPilotGetReceiptResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { GetReceiptJuniorPilotModel } from './get-receipt-junior-pilot.state';

/** StateDetailsActions */
const ACTION_SET = '[GetReceiptJuniorPilot] set';
const ACTION_UPDATE = '[GetReceiptJuniorPilot] update';
const ACTION_RESET = '[GetReceiptJuniorPilot] reset';
const ACTION_FAIL = '[GetReceiptJuniorPilot] fail';
const ACTION_CANCEL_REQUEST = '[GetReceiptJuniorPilot] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[GetReceiptJuniorPilot] set from api';
const ACTION_UPDATE_FROM_API = '[GetReceiptJuniorPilot] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setGetReceiptJuniorPilot = createAction(ACTION_SET, props<WithRequestId<GetReceiptJuniorPilotModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateGetReceiptJuniorPilot = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<GetReceiptJuniorPilotModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetGetReceiptJuniorPilot = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelGetReceiptJuniorPilotRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failGetReceiptJuniorPilot = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setGetReceiptJuniorPilotFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<JuniorPilotGetReceiptResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateGetReceiptJuniorPilotFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<JuniorPilotGetReceiptResponse>>()
);
